import Vue from 'vue'
import api from '@/api'

export const lookup = {
  namespaced: true,
  state: {
    lookups: {
      // 'contact.titleid': [],
      // 'currency': [],
      // 'billing.periodid': [],
      // 'business.statusid': [],
      // 'businessaddress.typeid': [],
      // 'businessinfo.annualrevenueid': [],
      // 'businessinfo.corporateaccountid': [],
      // 'businessinfo.dispatchpriorityid': [],
      // 'businessinfo.locationcountid': [],
      // 'businessinfo.monthlyrosid': [],
      // 'businessinfo.referralsourceid': [],
      // 'businessinfo.oemcertid': [],
      // 'businessinfo.salesrep': [],
      // 'businessinfo.distributor': [],
      // 'user.typeid': [],
      // 'discountmapping.mappingtypeid': [],
      // 'productdiscount.discounttypeid': []
    },
    lookupsZeus: {},
    serverProfiles: [],
    timezones: [],
    states: [],
    countries: [],
    languages: [],
    products: [],
    insuranceCompanies: [],
    vehicleManufacturers: [],
    vehicleMakes: [],
    productAdds: [],
    productMakes: [],
    groups: [],
    invoiceMethods: [],
    taxRates: [],
    scanTypes: [],
    launchAccounts: [],
    serviceElementGroups: [],
    deviceManufactureModels: [],
    brands: [],
    activationTypes: [],
    activationCards: [],
    hardwares: [],
    releaseTracks: [],
    suppliers: []
  },
  getters: {
    lookups: state => state.lookups,
    lookupsZeus: state => state.lookupsZeus,
    serverProfiles: state => state.serverProfiles,
    timezones: state => state.timezones,
    states: state => state.states,
    countries: state => state.countries,
    languages: state => state.languages,
    insuranceCompanies: state => state.insuranceCompanies,
    vehicleManufacturers: state => state.vehicleManufacturers,
    products: state => state.products,
    vehicleMakes: state => state.vehicleMakes,
    productAdds: state => state.productAdds,
    productMakes: state => state.productMakes,
    groups: state => state.groups,
    invoiceMethods: state => state.invoiceMethods,
    taxRates: state => state.taxRates,
    scanTypes: state => state.scanTypes,
    launchAccounts: state => state.launchAccounts,
    deviceManufactureModels: state => state.deviceManufactureModels,
    serviceElementGroups: state => state.serviceElementGroups,
    brands: state => state.brands,
    activationTypes: state => state.activationTypes,
    activationCards: state => state.activationCards,
    releaseTracks: state => state.releaseTracks,
    hardwares: state => state.hardwares,
    suppliers: state => state.suppliers
  },
  actions: {
    getLookups({ commit }, keys) {
      return new Promise((resolve, reject) => {
        api.lookups(keys, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_LOOKUPS', { keys, data: response.data })
            resolve(response)
          })
      })
    },
    getActivationTypes({ commit }) {
      return new Promise((resolve, reject) => {
        api.lookups(['device.activationtypeid'], { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_ACTIVATIONTYPES', { data: response.data })
            resolve(response)
          })
      })
    },
    getSuppliers({ commit }) {
      return new Promise((resolve, reject) => {
        api.lookups(['device.supplierid'], { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_SUPPLIERS', { data: response.data })
            resolve(response)
          })
      })
    },
    getLookupsZeus({ commit }, key) {
      return new Promise((resolve, reject) => {
        api.lookupsZeus(key, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_LOOKUPS_ZEUS', { key, data: response.data })
            resolve(response)
          })
      })
    },
    getLookupsByGroup({ commit }, { className, group }) {
      return new Promise((resolve, reject) => {
        api.lookupsByGroup({ className, group }, { headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_GROUPS', response.data)
            resolve(response)
          })
      })
    },
    getServerProfiles({ commit }) {
      return new Promise((resolve, reject) => {
        api.serverProfiles()
          .then(response => {
            commit('SET_SERVER_PROFILES', response.data)
            resolve(response)
          })
      })
    },
    getScanTypes({ commit }) {
      return new Promise((resolve, reject) => {
        api.scanTypes({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_SCAN_TYPES', response.data)
            resolve(response)
          })
      })
    },
    getActivationCards({ commit }) {
      return new Promise((resolve, reject) => {
        api.activationCards({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_ACTIVATION_CARDS', response.data)
            resolve(response)
          })
      })
    },
    getReleaseTracks({ commit }) {
      return new Promise((resolve, reject) => {
        api.releaseTracks({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_RELEASETRACKS', response.data)
            resolve(response)
          })
      })
    },
    getHardwares({ commit }) {
      return new Promise((resolve, reject) => {
        api.hardwares({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_HARDWARES', response.data)
            resolve(response)
          })
      })
    },
    getDeviceManufactureModels({ commit }) {
      return new Promise((resolve, reject) => {
        api.getDeviceManufactureModels({ headers: { 'content-type': 'application/json' } })
          .then(response => {
            commit('SET_DEVICE_MANUFACTURE_MODELS', response.data)
            resolve(response)
          })
      })
    },
    upsertLookup({ commit }, lookup) {
      return new Promise((resolve, reject) => {
        api.upsertLookup(lookup)
          .then(response => {
            lookup.id = response.data
            if (response.status === 200) {
              commit('SET_LOOKUP', lookup)
            }
            resolve(response)
          })
      })
    },
    upsertScanType({ commit }, scanType) {
      return new Promise((resolve, reject) => {
        api.upsertScanType(scanType)
          .then(response => {
            scanType.id = response.data
            if (response.status === 200) {
              commit('SET_SCAN_TYPE', scanType)
            }
            resolve(response)
          })
      })
    },
    upsertActivationCard({ commit }, activationCard) {
      return new Promise((resolve, reject) => {
        api.upsertActivationCard(activationCard)
          .then(response => {
            activationCard.id = response.data
            if (response.status === 200) {
              commit('SET_ACTIVATION_CARD', activationCard)
            }
            resolve(response)
          })
      })
    },
    upsertProduct({ commit }, product) {
      return new Promise((resolve, reject) => {
        api.upsertProduct(product)
          .then(response => {
            product.id = response.data
            product.hasDisclaimer = true
            if (!product.disclaimer || product.disclaimer.length === 0) {
              product.hasDisclaimer = false
            }
            if (response.status === 200) {
              commit('SET_PRODUCT', product)
            }
            resolve(response)
          })
      })
    },
    getTimeZones({ commit }) {
      return new Promise((resolve, reject) => {
        api.getTimeZones()
          .then(response => {
            commit('SET_TIMEZONES', response.data)
            resolve(response)
          })
      })
    },
    getStates({ commit }, id) {
      return new Promise((resolve, reject) => {
        api.getStates(id)
          .then(response => {
            commit('SET_STATES', response.data)
            resolve(response)
          })
      })
    },
    getCountries({ commit }) {
      return new Promise((resolve, reject) => {
        api.getCountries()
          .then(response => {
            commit('SET_COUNTRIES', response.data)
            resolve(response)
          })
      })
    },
    getLanguages({ commit }) {
      return new Promise((resolve, reject) => {
        api.getLanguages()
          .then(response => {
            commit('SET_LANGUAGES', response.data)
            resolve(response)
          })
      })
    },
    getInsuranceCompanies({ commit }) {
      api.getInsuranceCompanies()
        .then(response => {
          if (response.status === 200) {
            commit('SET_INSURANCE_COMPANIES', response.data)
          }
        })
    },
    getVehicleManufacturers({ commit }) {
      api.getVehicleManufacturers()
        .then(response => {
          if (response.status === 200) {
            commit('SET_VEHICLE_MANUFATURERS', response.data)
          }
        })
    },
    getProducts({ commit }) {
      return new Promise((resolve, reject) => {
        api.getProducts()
          .then(response => {
            commit('SET_PRODUCTS', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    getLaunchAccountList({ commit }) {
      return new Promise((resolve, reject) => {
        api.getLaunchAccountList()
          .then(response => {
            commit('SET_LAUNCH_ACCOUNTS', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    getVehicleMakes({ commit }, year) {
      api.getVehicleMakes(year)
        .then(response => {
          if (response.status === 200) {
            commit('SET_VEHICLE_MAKES', response.data)
          }
        })
    },
    getProductAdds({ commit }) {
      return new Promise((resolve, reject) => {
        api.getProductAdds()
          .then(response => {
            commit('SET_PRODUCTADDS', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    upsertProductAdd({ commit }, productAdd) {
      return new Promise((resolve, reject) => {
        api.upsertProductAdd(productAdd)
          .then(response => {
            productAdd.id = response.data
            if (response.status === 200) {
              commit('SET_PRODUCTADD', productAdd)
            }
            resolve(response)
          })
      })
    },
    getProductMakes({ commit }) {
      return new Promise((resolve, reject) => {
        api.getProductMakes()
          .then(response => {
            commit('SET_PRODUCTMAKES', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    upsertProductMake({ commit }, productMake) {
      return new Promise((resolve, reject) => {
        api.upsertProductMake(productMake)
          .then(response => {
            productMake.id = response.data
            if (response.status === 200) {
              commit('SET_PRODUCTMAKE', productMake)
            }
            resolve(response)
          })
      })
    }
  },
  mutations: {
    SET_LOOKUPS(state, { keys, data }) {
      if (data !== undefined && data !== null) {
        if (typeof keys === 'object') {
          if (data !== '') {
            keys.forEach(x => {
              Vue.set(state.lookups, x, data.filter(l => l.key === x))
            })
          }
        } else {
          Vue.set(state.lookups, keys, data)
        }
      }
    },
    SET_LOOKUPS_ZEUS(state, { key, data }) {
      Vue.set(state.lookupsZeus, key, data)
    },

    SET_SERVER_PROFILES(state, data) {
      state.serverProfiles = data
    },
    SET_DEVICE_MANUFACTURE_MODELS(state, data) {
      state.deviceManufactureModels = data
      var output = []
      var keys = []

      state.deviceManufactureModels.forEach(function (manufacture) {
        var key = manufacture.Brand

        if (keys.indexOf(key) === -1) {
          keys.push(key)
          output.push(manufacture)
        }
      })
      console.log(output)
      state.brands = output
      console.log(state.brands)
    },
    SET_SCAN_TYPES(state, data) {
      state.scanTypes = data
      console.log(state.scanTypes)
    },
    SET_ACTIVATION_CARDS(state, data) {
      console.log(data)
      state.activationCards = data
      console.log('activationCards', state.activationCards)
    },
    SET_RELEASETRACKS(state, data) {
      console.log(data)
      state.releaseTracks = data
      console.log('releaseTracks', state.releaseTracks)
    },
    SET_HARDWARES(state, data) {
      console.log(data)
      state.hardwares = data
      console.log('hardwares', state.hardwares)
    },
    SET_ACTIVATIONTYPES(state, data) {
      state.activationTypes = data.data
      console.log(state.activationTypes)
    },
    SET_SUPPLIERS(state, data) {
      console.log(data)
      state.suppliers = data.data
    },
    SET_SERVICE_ELEMENT_GROUPS(state, data) {
      state.serviceElementGroups = data
    },
    SET_SCAN_TYPE(state, data) {
      var idx = state.scanTypes.findIndex(i => i.id === data.id)
      console.log(idx)
      if (idx !== -1) {
        if (data.isInActive) {
          state.scanTypes.splice(idx, 1)
        } else {
          state.scanTypes[idx].text = data.text
          state.scanTypes[idx].serviceElementGroupId = data.serviceElementGroupId
          state.scanTypes[idx].serviceElementGroupName = data.serviceElementGroupName
        }
      } else {
        const lookup = {
          id: data.id,
          key: 'workorder.servicetype',
          text: data.text,
          isActive: data.isInActive === false,
          value: data.value,
          dateValue: null,
          decimalValue: null,
          intValue: null,
          label: null,
          parentId: null,
          stringValue: null,
          serviceElementGroupId: data.serviceElementGroupId,
          serviceElementGroupName: data.serviceElementGroupName
        }
        state.scanTypes.push(lookup)
      }
    },
    SET_ACTIVATION_CARD(state, data) {
      var idx = state.activationCards.findIndex(i => i.id === data.id)
      console.log(idx)
      if (idx !== -1) {
        state.activationCards[idx].activationCardId = data.activationCardId
        state.activationCards[idx].activationPassword = data.activationPassword
        state.activationCards[idx].assignedDate = data.assignedDate
        state.activationCards[idx].assignedDeviceId = data.assignedDeviceId
        state.activationCards[idx].activationAccountType = data.activationAccountType
        state.activationCards[idx].activationAccountReference = data.activationAccountReference
      } else {
        const activationCard = {
          id: data.id,
          activationCardId: data.activationCardId,
          activationPassword: data.activationPassword,
          activationAccountReference: data.activationAccountReference,
          activationAccountType: data.activationAccountType,
          assignedDate: null,
          assignedDeviceId: null,
          isActive: true
        }
        state.activationCards.push(activationCard)
      }
    },
    SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup)
      } else {
        var index = state.lookups[lookup.key].findIndex(i => i.id === lookup.id)
        state.lookups[lookup.key].splice(index, 1)
      }
    },
    SET_GROUPS(state, groups) {
      state.groups = []
      if (groups !== undefined && groups !== null) {
        if (groups !== '') {
          state.groups = groups
        }
      }
    },
    SET_TIMEZONES(state, timezones) {
      state.timezones = timezones || []
    },
    SET_STATES(state, states) {
      state.states = states || []
    },
    SET_COUNTRIES(state, countries) {
      state.countries = countries || []
    },
    SET_LANGUAGES(state, languages) {
      state.languages = languages || []
    },
    SET_LAUNCH_ACCOUNTS(state, launchAccounts) {
      console.log(launchAccounts.data)
      state.launchAccounts = launchAccounts.data || []
    },
    SET_INSURANCE_COMPANIES(state, insuranceCompanies) {
      state.insuranceCompanies = insuranceCompanies || []
    },
    SET_VEHICLE_MANUFATURERS(state, vehicleManufacturers) {
      state.vehicleManufacturers = vehicleManufacturers || []
    },
    SET_PRODUCTS(state, products) {
      state.products = products || []
      state.products.forEach(element => {
        element.isAdd = false
      })
    },
    SET_PRODUCT(state, product) {
      if (product.isActive) {
        if (product.id !== null && product.isAdd === false) {
          var idx = state.products.findIndex(i => i.id === product.id)
          state.products[idx] = product
        } else {
          state.products.push(product)
        }
      } else {
        var index = state.products.findIndex(i => i.id === product.id)
        state.products.splice(index, 1)
      }
    },
    SET_VEHICLE_MAKES(state, vehicleMakes) {
      state.vehicleMakes = vehicleMakes || []
    },
    SET_PRODUCTADDS(state, productAdds) {
      state.productAdds = productAdds || []
      state.productAdds.forEach(element => {
        element.isAdd = false
      })
    },
    SET_PRODUCTADD(state, productAdd) {
      if (productAdd.isActive) {
        if (productAdd.id !== null && productAdd.isAdd === false) {
          var idx = state.productAdds.findIndex(i => i.id === productAdd.id)
          state.productAdds[idx] = productAdd
        } else {
          state.productAdds.push(productAdd)
        }
      } else {
        var index = state.productAdds.findIndex(i => i.id === productAdd.id)
        state.productAdds.splice(index, 1)
      }
    },
    SET_PRODUCTMAKES(state, productMakes) {
      state.productMakes = productMakes || []
      state.productMakes.forEach(element => {
        element.isAdd = false
      })
    },
    SET_PRODUCTMAKE(state, productMake) {
      if (productMake.isActive) {
        if (productMake.id !== null && productMake.isAdd === false) {
          var idx = state.productMakes.findIndex(i => i.id === productMake.id)
          state.productMakes[idx] = productMake
        } else {
          state.productMakes.push(productMake)
        }
      } else {
        var index = state.productMakes.findIndex(i => i.id === productMake.id)
        state.productMakes.splice(index, 1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookup/index.js